import { Injectable, signal, WritableSignal } from '@angular/core';
import { NonClearingFilters } from '../../../models/clearing-course-search.models';

@Injectable({ providedIn: 'root' })
export class RemovedFiltersInfoService {
	#removedFilters: WritableSignal<NonClearingFilters[]> = signal([]);

	getRemovedFilters() {
		return this.#removedFilters;
	}

	setRemovedFilters(filters: NonClearingFilters[]) {
		this.#removedFilters.set(filters);
	}

	resetRemovedFilters() {
		this.#removedFilters.set([]);
	}
}
